import { MarketingRepo } from '@core/repositories'
const resource = "/contacts";

export default {
  stat (contactId, type, config) {
    return MarketingRepo.get(`${resource}/${contactId}/${type}.json`, config)
  },
  fetchAllCampaigns (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/get_all_campaigns.json`, config)
  },
  getRecentActivities (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/recent_activities.json`, config)
  },
  filters (contactId, config){
    return MarketingRepo.get(`${resource}/${contactId}/filters.json`,config)
  },
  /**
   * @used
   * 1. Marketing Contact 360 degree view (Contact Dashboard)
   */
  delete (contactId, config) {
    return MarketingRepo.post(`${resource}/${contactId}/pseudonymize_contact.json`, config)
  },
  getFieldsData (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/fields_data.json`, config)
  },
  setFields (contactId, data, config) {
    return MarketingRepo.post(`${resource}/${contactId}/set_fields.json`, data, config)
  },
  getContactsTags (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/tags.json`, config)
  },
  getSubscribedBrands (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/brands.json`, config)
  },
  dnmStatus (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/in_dnm.json`, config)
  },
  updateDNMStatus (isDNM, data, config) {
    if (isDNM) {
      return MarketingRepo.delete('/general_unsubscribes.json', { data }, config)
    } else {
      return MarketingRepo.post('/general_unsubscribes.json', data, config)
    }
  },
  updateDNMSms (isDNM, contactId, payload, config) {
		if (isDNM) {
			return MarketingRepo.delete(`sms_contacts/${contactId}/remove_from_dnm.json`, payload, config)
		} else {
			return MarketingRepo.post(`sms_contacts/${contactId}/add_to_dnm.json`, payload, config)
		}
	},
  getSubscribedLists (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/lists.json`, config)
  },
  updateTags (contactId, data, config) {
    return MarketingRepo.put(`${resource}/${contactId}/update_tags.json`, data, config)
  },
  getAllTags (config) {
    return MarketingRepo.get('/tags.json', config)
  },
  toggleBrandSubscription (contactId,data, config) {
    return MarketingRepo.post(`${resource}/${contactId}/toggle_brands_subscriptions.json`, data, config)
  },
  toggleSubscriptions (contactId, payload, config) {
    return MarketingRepo.post(`${resource}/${contactId}/toggle_subscriptions.json`, payload, config)
  },
  endJourney (journeyId, contactId, config) {
    return MarketingRepo.put(`/workflows/${journeyId}/stop/${contactId}`, config)
  },
  resetJourney (journeyId, contactId, config) {
    return MarketingRepo.put(`/workflows/${journeyId}/reset/${contactId}`, config)
  },
  showAbandonedItems (config) {
    return MarketingRepo.get(`${resource}/get_abandoned_items.json`, config)
  },
  getAbandonedCarts (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/abandoned_carts.json`, config)
  },
  getERFMScore (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/erfm_score.json`, config)
  },
  fetchSmsCampaigns (contactId, config) {
    return MarketingRepo.get(`${resource}/${contactId}/sms_campaigns.json`, config)
  },
  smsContactEngagingKeywords(contactId, payload = {}) {
		const endpoint = `${resource}/${contactId}/most_engaging_keywords.json`;
		return MarketingRepo.get(endpoint, payload);
	},
};
